import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import MyGuildView from '../MyGuildView/MyGuildView';
import { getMembers, getOneGuild } from '../../store/reducers/Guild/guildRequest';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setSocialStableNavigateBackRoute } from '../../store/reducers/Stable/slice';
const GuildView = () => {
    const dispatch = useDispatch();
    const param = useParams();
    const pathname = useLocation();
    const members = useSelector((state) => state.guild.members);
    const guildInfo = useSelector((state) => state.guild.guildInfo);
    useEffect(() => {
        //Saving the initial route for later navigating
        dispatch(setSocialStableNavigateBackRoute(pathname));
    }, []);
    const needUpdateGuild = useSelector((state) => state.guild.needUpdateGuild);
    useEffect(() => {
        dispatch(getMembers(param.id));
    }, [dispatch, param.id]);
    useEffect(() => {
        dispatch(getOneGuild(param.id));
    }, [dispatch, param.id]);
    useEffect(() => {
        if (needUpdateGuild) {
            dispatch(getOneGuild(param.id));
            dispatch(getMembers(param.id));
        }
    }, [dispatch, param.id, needUpdateGuild]);
    return (_jsx(MyGuildView, { guildInfoData: guildInfo, id: param.id, memberList: members || [], myGuildView: false }));
};
export default GuildView;
